import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://helpnao.com";

const cleanPath = (p = "/") => {
    const path = String(p).split("?")[0].split("#")[0];
    return path.startsWith("/") ? path : `/${path}`;
};

export default function SEO({
    title,
    description,
    path = "/",
    image = "/HelpNao192.png",
    noindex = false,
    lang = "en",
    jsonLd, // object or array
}) {
    const url = `${SITE}${cleanPath(path)}`;
    const ldArray = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

    return (
        <Helmet htmlAttributes={{ lang }}>
            <title>{title}</title>

            {description && <meta name="description" content={description} />}

            <link rel="canonical" href={url} />

            {noindex && (
                <>
                    <meta name="robots" content="noindex, nofollow" />
                    <meta name="googlebot" content="noindex, nofollow" />
                </>
            )}

            {/* OpenGraph */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            {description && <meta property="og:description" content={description} />}
            <meta property="og:url" content={url} />
            <meta property="og:image" content={`${SITE}${image}`} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            {description && <meta name="twitter:description" content={description} />}
            <meta name="twitter:image" content={`${SITE}${image}`} />

            {/* Structured data */}
            {ldArray.map((item, idx) => (
                <script key={idx} type="application/ld+json">
                    {JSON.stringify(item)}
                </script>
            ))}
        </Helmet>
    );
}
